import { parseApiError } from './apiError';
export interface AuditLogEntry {
  id_log: string;
  actor_id: string | null;
  action: string;
  target_type: string;
  target_id: string | null;
  details: string | null;
  created_at: string;
  actor_first_name?: string;
  actor_last_name?: string;
  actor_email?: string;
}

export const getAuditLogs = async (token: string): Promise<AuditLogEntry[]> => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}api/admin-audit-logs`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};
